import { SvgIcon } from '@mui/material';
import { Box } from '@mui/material';


export default function SpanishIcon (props) {

  return (
    <Box className={`${props?.className ? props.className : ''}`} sx={ props?.sx ? props.sx : {}}>
      <SvgIcon
        sx={{
          width: '100%',
          height: '100%'
        }}
        width="220"
        height="230"
        viewBox="0 0 382 253"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="spanish-icon">
        <rect id="vector-yellow" width="382" height="253" fill="#FFDA44"/>
        <g id="vector-red">
        <path d="M0 169H382V253.333H0V169Z" fill="#D80027"/>
        <path d="M0 0H382V84.3333H0V0Z" fill="#D80027"/>
        </g>
        </g>
      </SvgIcon>
    </Box>
  );
}
